var React = require('react');

function LeftChevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9 12.7l4.6 4.6c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4L11.1 12 15 8.1c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L9 11.3c-.4.4-.4 1 0 1.4z"}));
}

LeftChevron.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = LeftChevron;

LeftChevron.default = LeftChevron;
